var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C8.13078 5 5 8.13105 5 12C5 15.8692 8.13105 19 12 19C15.8692 19 19 15.8689 19 12C19 8.13078 15.8689 5 12 5ZM12 17.9062C8.73535 17.9062 6.09375 15.2644 6.09375 12C6.09375 8.73535 8.73557 6.09375 12 6.09375C15.2647 6.09375 17.9062 8.73557 17.9062 12C17.9062 15.2647 15.2644 17.9062 12 17.9062ZM12 10.8606C11.698 10.8606 11.4531 11.1054 11.4531 11.4075V14.9291C11.4531 15.2312 11.698 15.476 12 15.476C12.302 15.476 12.5469 15.2312 12.5469 14.9291V11.4075C12.5469 11.1054 12.302 10.8606 12 10.8606ZM12.7383 9.45266C12.7383 9.8604 12.4077 10.1909 12 10.1909C11.5923 10.1909 11.2617 9.8604 11.2617 9.45266C11.2617 9.04492 11.5923 8.71438 12 8.71438C12.4077 8.71438 12.7383 9.04492 12.7383 9.45266Z",
    fill: "#3399FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ba440a26a2eeae844f20463a2859c093.svg";
export { ForwardRef as ReactComponent };